import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS  } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatasourceListComponent } from './datasource-list/datasource-list.component';
import { 
  DxDataGridModule,
  DxSelectBoxModule,
  DxCheckBoxModule,
  DxButtonGroupModule,
  DxHtmlEditorModule
} from 'devextreme-angular';

@NgModule({
  declarations: [
    DatasourceListComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxButtonGroupModule,
    DxHtmlEditorModule,
    CommonModule
  ]
})
export class DatasourceModule { }
